import React from 'react';
import cn from 'classnames';
import {
  InputLabel,
  Grid,
  Chip,
  FormControl,
  FormHelperText,
} from '@material-ui/core';
import styles from './index.module.scss';
import { MultiselectItem } from "../Multiselect";

type MultiChipsProps = {
  title?: string;
  name: string;
  items?: MultiselectItem[];
  classes?: {
    wrapper?: string;
    select?: string;
  };
  helperText?: React.ReactNode,
  error?: boolean,
  selectedItems?: MultiselectItem[];
  onChange: (values?: (number | string)[]) => any;
  onDelete?: (value: MultiselectItem) => any;
};

const MultiChips = ({
  title,
  name,
  items = [],
  onChange,
  selectedItems = [],
  classes,
  onDelete,
  helperText = null,
  error,
}: MultiChipsProps) => {
  const onChipClick = (value: MultiselectItem) => {
    if (selectedItems.find((item) => item.id === value.id)) {
      if (onDelete) {
        onDelete(value);
      } else {
        const newValues = selectedItems.filter((item) => item.id !== value.id).map((item) => item.id);
        onChange(newValues);
      }

      return;
    }

    const newValues = [ ...selectedItems, value ].map((item) => item.id);
    onChange(newValues);
  };

  return (
    <FormControl
      className={cn(classes?.wrapper, styles.wrapper)}
      variant='outlined'
      error={error}
    >
      <InputLabel id={name} className={styles.label}>
        {title}
      </InputLabel>
      <Grid container className={styles.chipsContainer}>
        {items.map(({ id, name }) => {
            return (
              <Chip
                key={id}
                label={name}
                className={styles.chip}
                color={selectedItems.find((item) => item.id === id) ? 'primary' : 'default'}
                onClick={() => {onChipClick({ id, name });}}
              />
            );
          },
        )}
      </Grid>
      {
        error && <FormHelperText>{helperText}</FormHelperText>
      }
    </FormControl>
  );
};

export default MultiChips;
